<ng-container *ngIf="{
    row: columnData | async
  } as $">
<p >{{clientGender[$.row!.clt_gender]}}</p>
</ng-container>
